/* eslint-disable no-dupe-keys */
export default {
  order_refund: {
    name: '订单退款',
    // 属性（一般与对象内容匹配）
    prop: {
      serial_number: '单号',
      order: '订单',
      sp_refund_amount: '运营商退款',
      platform_refund_amount: '平台商退款',
      internal_remark: '内部备注',
      total_refund_amount: '总退款金额',
      target_idle_fee_amount: '目标占位费',
      service_provider: '运营商',
      status: '状态',
      created_at: '申请时间',
      updated_at: '更新时间',
      refunded_at: '退款时间',
      refund_consumed_power: '退减电量',
      ev_charging_station: '充电站',
      user: '用户',
      target_detail_bills: '目标分时账单',
      audit_description: '审核说明',
      service_refund_amount: '服务费退款',
      electric_refund_amount: '电费退款',
      idle_fee_refund_amount: '占位费退款',
      balance_before_refunded: '退款前余额',
      balance_after_refunded: '退款后余额'
    },
    // Enum的属性
    statuses: {
      pending: '待审核',
      passed: '已退款',
      rejected: '已拒绝'
    },
    transitions: {
      pass: '审核通过',
      reject: '拒绝'
    },
    // Boolean的属性
    // 占位提示
    placeholder: {
      search_keyword: '查询退款单号/订单号',
      input_internal_remark: '电损过高/占位费错收/离网计费(仅内部可见)',
      input_audit_description: '审核说明（仅内部可见）'
    },
    // 详情页标签
    detail_tags: {
      detail: '基本信息'
    },
    // 标签标题
    list_tabs: {
      all: '全部',
      pending: '待审核',
      passed: '已退款',
      rejected: '已拒绝'
    },
    // 标题
    titles: {
      base_info: '基本信息',
      target_order_info: '订单的目标费用',
      refund_info: '退款信息',
      order_info: '原订单信息',
      target_order_info: '目标(退款后)订单',
      audit_work_order: '审核工单'
    },
    tips: {
      before_passed: '审核通过，退款金额会自动返还到用户的账户余额',
      before_rejected: '拒绝后，如果有需要可以重新申请退款',
      header: '订单退款需要人工计算运营商承担部分（扣除渠道费、交易手续费等），然后手动登记结算信息'
    },
    labels: {
      total_refund_amount: '总退款金额',
      service_refund_amount: '服务费退款',
      electric_refund_amount: '电费退款',
      idle_fee_refund_amount: '占位费退款'
    }
  }
}
